module.exports = __webpack_public_path__ + "static/media/lizTable-02.7691ee95.jpg";